import React from 'react'
import styles from './ToxboxSection.module.css';

function whatIsToxbox() {
  return (
      <section className={styles.whatIsToxbox}>
          <h2 className={styles.title}>What is TOXBOX?</h2>
        <p className={styles.description}>
          ToxBox AI is a cloud-based voice automation platform that uses conversational AI to manage business calls efficiently. It is designed for companies that want to streamline customer communication by using AI voice agents for both inbound and outbound calls.
        </p>
        <p className={styles.description}>
          The platform helps businesses automate repetitive call tasks, reduce dependency on human agents, and improve customer experience with fast, intelligent, and context-aware voice interactions.
        </p>

        <h3 className={styles.subheading}>🔷 Key Capabilities</h3>
        <ul className={styles.capabilitiesList}>
          <li>Automated Call Handling: Managing routine inquiries and directing calls appropriately.</li>
          <li>24/7 Availability: Ensuring customers can reach support at any time.</li>
          <li>Natural Language Processing: Understanding and responding to customer queries in a conversational manner.</li>
          <li>Integration with Business Tools: Connecting with CRM systems and other software to provide context-aware responses.</li>
        </ul>

        <div className={styles.featuresBox}>
         <img src='https://imgs.search.brave.com/d7hdgR2wo8vme9JxVoyqWS67f2y9OU0WTzezyt438Pg/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9jb250/ZW50LW1hbmFnZW1l/bnQtZmlsZXMuY2Fu/dmEuY29tL2Nkbi1j/Z2kvaW1hZ2UvZj1h/dXRvLHE9NzAvYWI3/ZGJlMDAtOTQ1NC00/ZDRiLTg4NmQtODFk/ODUyODUwOTY1L21h/Z2ljLXBob3RvX2lu/dGVybmFsLWxpbmsy/eC5wbmc' />
        </div>
        </section>
  )
}

export default whatIsToxbox